import React, { FC, useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";
import { style as checkoutHeader } from "./CheckoutHeader.style";

interface CheckoutHeaderProps {
  readonly onBack?: () => void;
}

const CheckoutHeader: FC<CheckoutHeaderProps> = ({ onBack }) => {
  const title = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HEADER_COMPLETE_CHECKOUT_TITLE });

  const style = useMemo(() => checkoutHeader(), []);

  return (
    <Header testID="checkout-header">
      <ButtonIcon name="arrow_left" style={{ button: style.button }} testID="arrow-left-button-icon" onPress={onBack} />
      <Text level={3} variant="action">
        {title}
      </Text>
      <ButtonIconPlaceholder />
    </Header>
  );
};

export { CheckoutHeader };
